import api from './api';
import { Colaborador } from './colaboradorService';
import { Ramo } from '../types/ramo';

export enum MesCompetencia {
    JANEIRO = 'JANEIRO',
    FEVEREIRO = 'FEVEREIRO',
    MARCO = 'MARCO',
    ABRIL = 'ABRIL',
    MAIO = 'MAIO',
    JUNHO = 'JUNHO',
    JULHO = 'JULHO',
    AGOSTO = 'AGOSTO',
    SETEMBRO = 'SETEMBRO',
    OUTUBRO = 'OUTUBRO',
    NOVEMBRO = 'NOVEMBRO',
    DEZEMBRO = 'DEZEMBRO',
}

export interface MetaColaborador {
    id: number;
    colaborador: Colaborador;
    ramo: Ramo;
    ano: string;
    mes: MesCompetencia;
    valorMeta: number;
    createdAt: string;
    updatedAt: string;
}

export interface CreateMetaDTO {
    colaboradorId: number;
    ramoId: number;
    ano: string;
    mes: MesCompetencia;
    valorMeta: number;
}

export interface UpdateMetaDTO {
    valorMeta: number;
}

export interface ListarMetasFiltros {
    colaboradorId?: number | '';
    ramoId?: number | '';
    ano?: string;
    mes?: MesCompetencia | '';
    page?: number;
    limit?: number;
}

const listar = async (filtros: ListarMetasFiltros): Promise<{ data: MetaColaborador[], total: number }> => {
    const params: any = {};
    if (filtros.colaboradorId) params.colaboradorId = filtros.colaboradorId;
    if (filtros.ramoId) params.ramoId = filtros.ramoId;
    if (filtros.ano) params.ano = filtros.ano;
    if (filtros.mes) params.mes = filtros.mes;
    if (filtros.page) params.page = filtros.page;
    if (filtros.limit) params.limit = filtros.limit;

    const response = await api.get('/metas-colaborador', { params });
    return response.data;
};

const criar = async (data: CreateMetaDTO): Promise<MetaColaborador> => {
    const response = await api.post('/metas-colaborador', data);
    return response.data;
};

const atualizar = async (id: number, data: UpdateMetaDTO): Promise<MetaColaborador> => {
    const response = await api.put(`/metas-colaborador/${id}`, data);
    return response.data;
};

const excluir = async (id: number): Promise<void> => {
    await api.delete(`/metas-colaborador/${id}`);
};

export const metaColaboradorService = { listar, criar, atualizar, excluir };